<template>
  <v-navigation-drawer
    app
    color="grey lighten-5"
    width="240"
    clipped
    permanent
    disable-resize-watcher
  >
    <div class="menu my-3">
      <v-list dense nav>
        <v-list-item
          :key="i"
          v-for="(item, i) in items"
          class="px-6 py-0"
          :to="item.link"
          v-granted="item.permission"
          color="primary"
        >
          <v-list-item-icon class="mr-4">
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <span
                class="body-2 font-weight-medium"
                v-text="$t(`${item.text}`)"
              ></span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import sidebarMenus from "@/utils/sidebarMenus";
export default {
  data: () => ({
    selectedItem: 1,
    items: [...sidebarMenus],
  }),
};
</script>

<style>
.v-list--nav .v-list-item,
.v-list--nav .v-list-item:before {
  border-radius: 12px !important;
}

.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 44px;
}

.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  color: rgba(0, 0, 0, 0.6);
}
</style>